import { ResetPasswordPage } from '@ubus/shared';
import { useTranslation } from 'react-i18next';

function ResetPassword() {
  const { t } = useTranslation();

  return (
    <ResetPasswordPage
      successRedirect="/login"
      titleColor="#ea580c"
      primaryColor="#ea580c"
      portalLabel={t('account.resetPortalLabel')}
      labels={{
        invalidLink: t('account.invalidLink'),
        newPassword: t('account.newPassword'),
        enterNewPassword: t('account.enterNewPassword'),
        confirmPassword: t('account.confirmPassword'),
        confirmYourPassword: t('account.confirmYourPassword'),
        savePassword: t('account.savePassword'),
        mismatch: t('account.mismatch'),
        tooShort: t('account.tooShort'),
        updatedSignIn: t('account.updatedSignIn'),
      }}
    />
  );
}

export default ResetPassword;
